import { render, staticRenderFns } from "./FlatCrossSection.vue?vue&type=template&id=1c1efe2e&scoped=true"
import script from "./FlatCrossSection.vue?vue&type=script&lang=ts"
export * from "./FlatCrossSection.vue?vue&type=script&lang=ts"
import style0 from "./FlatCrossSection.vue?vue&type=style&index=0&id=1c1efe2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1efe2e",
  null
  
)

export default component.exports